import React, { FC } from 'react';

import {
  Tariffs,
  Seances,
  LoyaltySystem,
  Tour,
  Vote,
  Authorization,
} from './components';

export const BillingTab: FC = () => {
  return (
    <>
      <Tariffs />
      <Seances />
      <LoyaltySystem />
      <Tour />
      <Authorization />
      <Vote />
    </>
  );
};
